import { FC, MouseEvent, ReactNode, FormEvent } from 'react';
import DBHeader from 'src/components/Headers/DialogBoxHeader';
import Scrollbar from 'src/components/StyledComponents/StyledScrollbar';
import {
  SecondaryButton,
  FormTitleTypography,
  FormContentBox,
  ButtonContainerBox,
  StyledCircularProgress,
  RelativePositionBox,
} from 'src/components/DialogBox/POBox/POBox.styles';
import {
  StyledDialog,
  CloseIcon,
  StyledDialogContent,
  SubmitButton,
} from 'src/components/DialogBox/DialogBox.styles';
import { ButtonContainerAddGrn } from '../GRNPaymentDialog/GRNPaymentDialog.styles';

interface GRNDialogProps {
  height?: string;
  width?: string;
  open: boolean;
  handleClose: () => void;
  title: string;
  subtitle: string;
  formTitle: string;
  children: ReactNode;
  onSubmit: (e?: FormEvent<HTMLFormElement>) => void;
  smScreen?: boolean;
  buttonLabel?: string;
  buttonLabel2?: string;
  buttonWidth?: string;
  buttonDisabled?: boolean;
  onSaveClick?: () => void;
  onSaveAndCompleteClick?: () => void;
}

const GRNDialog: FC<GRNDialogProps> = ({
  height = '720px',
  width = '984px',
  open,
  handleClose,
  title,
  subtitle,
  formTitle,
  children,
  onSubmit,
  smScreen,
  buttonLabel = 'Save',
  buttonLabel2,
  buttonWidth = '100px',
  buttonDisabled,
  onSaveClick,
  onSaveAndCompleteClick,
}) => {
  const handleSave = (e: MouseEvent) => {
    e.preventDefault();
    onSaveClick?.();
  };

  const handleSaveAndComplete = (e: MouseEvent) => {
    e.preventDefault();
    onSaveAndCompleteClick?.();
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      width={width}
      height={height}
    >
      <RelativePositionBox>
        <DBHeader title={title} subtitle={subtitle} />
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </RelativePositionBox>
      <Scrollbar thumbColor="var(--loader-color)">
        <StyledDialogContent>
          <form onSubmit={onSubmit}>
            <FormTitleTypography ml={5} mb={2}>
              {formTitle}
            </FormTitleTypography>
            <FormContentBox>{children}</FormContentBox>
            <ButtonContainerAddGrn>
              <SubmitButton
                className="btn-primary"
                type="button"
                disabled={buttonDisabled}
                buttonWidth={buttonWidth}
                onClick={handleSave}
              >
                {buttonDisabled ? (
                  <StyledCircularProgress size={24} />
                ) : (
                  buttonLabel
                )}
              </SubmitButton>
              {buttonLabel2 && (
                <SecondaryButton
                  className="btn-primary"
                  type="button"
                  disabled={buttonDisabled}
                  onClick={handleSaveAndComplete}
                >
                  {buttonDisabled ? (
                    <StyledCircularProgress size={24} />
                  ) : (
                    buttonLabel2
                  )}
                </SecondaryButton>
              )}
            </ButtonContainerAddGrn>
          </form>
        </StyledDialogContent>
      </Scrollbar>
    </StyledDialog>
  );
};

export default GRNDialog;
